import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { environment } from 'environments/environment';
import {
    CookieValue,
    getCookie,
    run,
    showPreferences,
} from 'vanilla-cookieconsent';

@Injectable({
    providedIn: 'root',
})
export class CookieconsentService {
    private config: any;
    private readonly API_URL = environment.api.snc.url;

    constructor(
        private _httpClient: HttpClient,
        private _oidcSecurityService: OidcSecurityService
    ) {
        this.config = this.getDefaultConfig();
    }

    private getDefaultConfig() {
        return {
            manageScriptTags: false,
            guiOptions: {
                consentModal: {
                    layout: 'box wide',
                    position: 'bottom center',
                    equalWeightButtons: true,
                    flipButtons: false,
                },
                preferencesModal: {
                    layout: 'box',
                    equalWeightButtons: true,
                    flipButtons: false,
                },
            },
            onFirstConsent: ({ cookie }) => {
                this.almacenarPreferencias(cookie);
            },
            onConsent: ({ cookie }) => {},
            onChange: ({ cookie, changedCategories, changedServices }) => {
                this.almacenarPreferencias(cookie);
            },
            onModalShow: ({ modalName }) => {},
            onModalHide: ({ modalName }) => {},
            categories: {
                necessary: {
                    enabled: true,
                    readOnly: true,
                    services: {
                        recaptcha: {
                            label: 'Recaptcha v3 Google',
                            onAccept: () => {
                                // Recaptcha logic
                            },
                            onReject: () => {
                                // Logic for when the user rejects
                                // the recaptcha service
                            },
                        },
                    },
                },
                analytics: {
                    enabled: false,
                    readOnly: false,
                    services: {
                        another: {
                            label: 'Generic Service',
                            onAccept: () => {},
                            onReject: () => {},
                        },
                    },
                },
                ads: {
                    enabled: false,
                    readOnly: false,
                },
            },
            language: {
                default: 'es',
                translations: {
                    es: {
                        consentModal: {
                            title: 'Usamos cookies',
                            description:
                                'Usamos cookies para garantizar el funcionamiento de la plataforma educativa, y con tu permiso, para analizar tu comportamiento y mejorar nuestros servicios.',
                            acceptAllBtn: 'Aceptar todas',
                            acceptNecessaryBtn: 'Solo necesarias',
                            showPreferencesBtn: 'Gestionar preferencias',
                            footer: `
                    <a href="https://fmf.mx/privacidad/aviso-de-privacidad-integral-del-sistema-nacional-de-formacion_145" target="_blank">
                      Aviso de Privacidad
                    </a>
                  `,
                        },
                        preferencesModal: {
                            title: 'Preferencias de cookies',
                            acceptAllBtn: 'Aceptar todas',
                            acceptNecessaryBtn: 'Solo necesarias',
                            savePreferencesBtn: 'Guardar preferencias',
                            closeIconLabel: 'Cerrar',
                            serviceCounterLabel: 'Servicio|Servicios',
                            sections: [
                                {
                                    title: 'Uso de cookies',
                                    description:
                                        'Nuestra plataforma utiliza cookies necesarias para iniciar sesión y mantener la navegación.',
                                },
                                {
                                    title: 'Cookies estrictamente necesarias <span class="pm__badge">siempre activas</span>',
                                    description:
                                        'Estas cookies permiten el inicio de sesión, el registro y la seguridad del sitio.',
                                    linkedCategory: 'necessary',
                                },
                                // {
                                //     title: 'Cookies de análisis',
                                //     description:
                                //         'Estas cookies nos ayudan a entender el comportamiento de los usuarios para mejorar la experiencia.',
                                //     linkedCategory: 'analytics',
                                // },
                                // {
                                //     title: 'Cookies publicitarias',
                                //     description:
                                //         'Utilizadas para personalizar anuncios (actualmente no activas).',
                                //     linkedCategory: 'ads',
                                // },
                                {
                                    title: 'Enlaces',
                                    description: `
                                      <a href="https://fmf.mx/privacidad/aviso-de-privacidad-integral-del-sistema-nacional-de-formacion_145" target="_blank">
                                        Aviso de Privacidad
                                      </a>
                                    `,
                                },
                            ],
                        },
                    },
                },
            },
        };
    }

    initCookieConsent(): void {
        run(this.config);
    }

    showPreferences(): void {
        showPreferences();
    }

    almacenarPreferenciasWithUsuario() {
        const cookie = getCookie();
        if (
            !cookie ||
            (typeof cookie === 'object' && Object.keys(cookie).length === 0)
        ) {
            // No hay preferencias para almacenar
            return;
        }
        this.almacenarPreferencias(cookie);
    }

    almacenarPreferencias(cookie: CookieValue): void {
        const isAuthenticated =
            this._oidcSecurityService.authenticated().isAuthenticated;
        console.log('isAuthenticated', isAuthenticated);

        if (!isAuthenticated) {
            console.info('No se almacenan preferencias, no autenticado');
            return;
        }

        this._httpClient
            .post(`${this.API_URL}/cookie-consent`, cookie)
            .subscribe({
                next: (response) => {},
                error: (error) => {
                    console.error('Error al almacenar preferencias', error);
                },
            });
    }
}
